// Module
var code = `
<table class="table">
	<tr ng-repeat="model in migration_status">
		<td>{{model.name}}</td>
		<td>{{model.count}}</td>
		<td>{{model.es_count}}</td>
		<td>{{model.days}}</td>
	</tr>
</table>`;
// Exports
module.exports = code;